<script lang="ts">
    import Dialog, {Title, Content, Actions} from '@smui/dialog';
    import InputNumber from "../atoms/InputNumber.svelte";
    import {getFormatter} from "../../utils";
    import {CartStockItem} from "../../interfaces";
    import {createEventDispatcher} from "svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let data: CartStockItem;
    let formatter = getFormatter();
    let dispatch = createEventDispatcher();

    let openDialog: boolean = false;

    function remove() {
        openDialog = false;
        dispatch('remove');
    }

    function cancelRemove() {
        openDialog = false;
    }
</script>
<div>
    <div class="grid-auto-1 gap-1 mb-ii">
        <div style="width: 111px">
            {#if data.item.route}
                <a href={data.item.route??'#'} target="_blank">
                    {#if data.item.image}
                        <img class="w-100" src="{data.item.image}" alt="{data.item.name}">
                    {:else}
                        <img class="w-100" src="/static/storefront/pix/no_foto.jpg" alt="No photo">
                    {/if}
                </a>
            {:else}
                {#if data.item.image}
                    <img class="w-100" src="{data.item.image}" alt="{data.item.name}">
                {:else}
                    <img class="w-100" src="/static/storefront/pix/no_foto.jpg" alt="No photo">
                {/if}
            {/if}
        </div>
        <div>
            <div class="box-b">
                <div>
                    {#if data.brand}
                        <div style="font-size: 12px">{data.brand}</div>
                    {/if}
                </div>
                <div on:click={()=>openDialog=true}>
                    <img height="15" src="/static/storefront/pix/icons/eliminar.svg" alt="Eliminar">
                </div>
            </div>
            <strong class="block" style="font-size: 14px">{data.item.name}</strong>
            {#if data.item.delivery}
                <div class="box-l sx-ii py-ii">
                    <img height="15" src="/static/storefront/pix/icons/entrega.svg" alt="Entrega">
                    <p style="font-size:15px">Tiempo de envío: {data.tiempoDespacho} días</p>
                </div>
            {/if}
            <div class="box-b">
                <div>
                    {#if data.flag}
                        <div class="discount">{data.flag}</div>
                        {#if data.prevPrice}
                            <small>Antes {formatter(data.prevPrice)}</small>
                        {/if}
                    {/if}
                    <div class="price">{formatter(data.price)}</div>
                </div>
                <div>
                    <InputNumber bind:value={data.quantity}
                                 on:updateQuantity/>
                </div>
            </div>

            <!--
            {#if data.item.installationEnabled}
                <div class="my-1">
                    <label for="id-{data.sku}">
                        <input id="id-{data.sku}" bind:value={data.installValue} type="checkbox">
                        <span>¿Incluir servicio de instalación?</span>
                    </label>
                </div>
            {/if}
            {#if data.installOption && data.installValue}
                <input class="naui-input" placeholder="Placa">
            {/if}
            -->
        </div>
    </div>
</div>
<Dialog bind:open={openDialog}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        ¿Desea eliminar el repuesto <b>{data.item.name}</b> del carrito?
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="CANCELAR"
                        mode="solid"
                        on:click={()=>cancelRemove()}/>
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>remove()}/>
        </div>
    </Actions>
</Dialog>

<style>
    .discount {
        background: black;
        color: white;
        font-size: 12px;
        font-weight: bold;
        width: max-content;
        padding: 5px;
    }
</style>